export const ACCESSIBILITY_POLICY = {
  id: 'accessibility-policy',
  title: 'Accessibility Policy',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'all',
  content: `ACCESSIBILITY POLICY — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This policy sets out Reservo's commitments to passengers with disability and the operational measures supporting equal access to point-to-point passenger transport.

2. LEGAL FRAMEWORK

2.1 This policy aligns with:
  (a) Disability Discrimination Act 1992 (Cth);
  (b) Anti-Discrimination Act 1977 (NSW);
  (c) Disability Standards for Accessible Public Transport 2002 (Cth);
  (d) Point to Point Transport (Taxis and Hire Vehicles) Act 2016 (NSW).

3. STATEMENT OF COMMITMENT

3.1 Reservo is committed to providing equal access to its booking service for passengers with disability.

3.2 Discrimination on the basis of disability is unlawful and is prohibited on the Reservo platform.

4. RIDER FACILITIES

4.1 Riders may indicate, on their profile or at booking time, the following accessibility requirements:
  (a) wheelchair (folding, manual, or powered);
  (b) other mobility aid (walking frame, crutches, prosthetic);
  (c) guide or support animal;
  (d) communication support (sign language, large print, plain language);
  (e) cognitive or psychiatric support;
  (f) requirement for a specific accessible vehicle.

4.2 The Reservo platform filters available Drivers and vehicles by accessibility capability so that only suitable matches are offered for a booking.

5. DRIVER OBLIGATIONS

5.1 A Driver who has accepted a booking with declared accessibility requirements must provide reasonable accommodation, including:
  (a) safely stowing mobility aids;
  (b) assisting with loading and unloading where requested and safely possible;
  (c) transporting guide and support animals without additional charge;
  (d) communicating in plain language or by alternative means where required;
  (e) driving at moderate speeds and with smooth braking and cornering.

5.2 A Driver must NOT:
  (a) refuse to transport a passenger because of disability;
  (b) refuse a guide or support animal;
  (c) charge an additional fee for accessibility accommodation;
  (d) require the passenger to transfer out of a wheelchair where the vehicle is wheelchair-accessible and the passenger prefers not to transfer;
  (e) display impatience, hostility, or condescension.

5.3 Refusal of service on the basis of disability is a serious breach of this policy and may result in immediate suspension and referral to authorities.

6. ASSISTANCE ANIMALS

6.1 An assistance animal is any animal trained to alleviate the effect of a disability and meeting hygiene and behavioural standards (Disability Discrimination Act 1992 (Cth), section 9).

6.2 A Driver:
  (a) MUST carry an assistance animal at no extra charge;
  (b) MAY request to see the animal's accreditation if it is not visibly identified;
  (c) MAY NOT refuse the animal unless it is poorly behaved or poses a hygiene risk that no reasonable accommodation can address.

6.3 A passenger denied service with an assistance animal may submit a complaint to Reservo and/or:
  (a) the Australian Human Rights Commission;
  (b) NSW Anti-Discrimination Board;
  (c) NSW Point to Point Transport Commissioner.

7. WHEELCHAIR ACCESSIBILITY

7.1 Drivers may opt in to indicate that their vehicle is wheelchair-accessible. Opt-in requires:
  (a) vehicle modification certification (where relevant);
  (b) self-declaration that the vehicle can safely accommodate a wheelchair;
  (c) photo evidence of accessibility features (e.g. ramp, lift, securement points).

7.2 Wheelchair-accessible bookings are matched only to opted-in Drivers.

7.3 Reservo audits wheelchair-accessibility declarations periodically.

8. APP ACCESSIBILITY

8.1 The Reservo platform is designed in alignment with WCAG 2.1 AA accessibility standards.

8.2 Features include:
  (a) compatibility with iOS VoiceOver and Android TalkBack screen readers;
  (b) high colour contrast for text and interactive controls;
  (c) accessible form labelling;
  (d) scaling text size;
  (e) clear focus indication for keyboard navigation.

8.3 Accessibility issues with the app may be reported to admin@reservo.au.

9. COMPLAINTS

9.1 Discrimination complaints are triaged as priority through the in-app complaints feature or admin@reservo.au.

9.2 Substantiated complaints may result in:
  (a) immediate driver suspension pending investigation;
  (b) termination if discrimination is confirmed;
  (c) referral to the NSW Point to Point Transport Commissioner;
  (d) referral to the Australian Human Rights Commission or NSW Anti-Discrimination Board.

10. TRAINING

10.1 Drivers complete a mandatory disability-awareness and assistance-animal module at onboarding and annually thereafter.

10.2 Reservo personnel receive equivalent training.

11. REVIEW

11.1 This policy is reviewed at least annually and following any substantiated discrimination complaint.

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};